import { useTranslation } from 'react-i18next';
import { CommonDocumentService } from '@umanforge/common';

interface StorageStatValueProps {
  label: string;
  /** value en Ko (kilo-octets). */
  value: number;
  className?: string;
}

export function StorageStatValue( { label, value, className }: StorageStatValueProps ) {
  const { t } = useTranslation();
  const display = CommonDocumentService.getReadableFileSizeString( value );
  return (
    <div className={ `flex flex-col gap-1 ${ className ?? '' }`.trim() }>
      <span className='text-sm text-gray-500'>{ t( label ) }</span>
      <span className='text-lg font-medium text-gray-800'>{ display }</span>
    </div>
  );
}
